import React, {useState, useEffect} from 'react'
import './Navbar.css'
import honeyLogo from '../../Components/assets/HoneyBtn.JPG'

export default function Navbar() {
  const [toggleMenu, setToggleMenu] = useState(false)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)


  const toggleNav = () => {
    setToggleMenu(!toggleMenu)
  }

  useEffect(() => {

    const changeWidth = () => {
      setScreenWidth(window.innerWidth);
    }

    window.addEventListener('resize', changeWidth)

    return () => {
        window.removeEventListener('resize', changeWidth)
    }

  }, [])

  return (
    <nav>
      {(toggleMenu || screenWidth > 500) && (
      <ul className="list">
      <li className="items">درباره ما</li>
      <li className="items">پشتیبانی</li>
      <li className="items">کالاها</li>
      <li className="items">خانه</li>
    </ul>
      )}

      <button onClick={toggleNav} className="btn"><img  width="80" height="80" src={honeyLogo} alt='عسل' ></img></button>
    </nav>
  )
}
